import React, { useEffect, useState } from "react";
import "./ExitIntentPopup.css";
import { Apiurl, GetLocalStorageParsed, parseData } from "../../Pages/utils/page";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

const ExitIntentPopup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasItems, setHasItems] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const navigate = useNavigate();

    const fetchToken = GetLocalStorageParsed("AuthToken");

    useEffect(() => {
        // Check if there are items in the cart
        const checkCart = async () => {
            if (!fetchToken) return;
            
            try {
                const response = await axios.get(`${Apiurl()}/api/Order/CustomerOrders`, {
                    headers: { Authorization: `Bearer ${fetchToken}` }
                });
                const data = parseData(response.data.result);
                // If there's at least one pending order or item
                if (data && data.length > 0) {
                    setHasItems(true);
                }
            } catch (error) {
                console.error("Error checking cart for exit intent:", error);
            }
        };

        checkCart();
    }, [fetchToken]);

    useEffect(() => {
        // Only attach if user has items and hasn't seen it this session
        const sessionDismissed = sessionStorage.getItem("exitIntentDismissed");
        if (sessionDismissed || dismissed || !hasItems) return;

        const handleMouseLeave = (e) => {
            // If mouse moves above the top of the browser window
            if (e.clientY <= 0) {
                setIsVisible(true);
            }
        };

        document.addEventListener("mouseleave", handleMouseLeave);
        return () => document.removeEventListener("mouseleave", handleMouseLeave);
    }, [hasItems, dismissed]);

    const handleClose = () => {
        setIsVisible(false);
        setDismissed(true);
        sessionStorage.setItem("exitIntentDismissed", "true");
    };

    const handleContinue = () => {
        handleClose();
        navigate("/cart-details");
    };

    if (!isVisible) return null;

    return (
        <div className="exit-intent-overlay">
            <div className="exit-intent-modal">
                <button className="exit-close-btn" onClick={handleClose}>
                    <RxCross2 />
                </button>
                <div className="exit-intent-content">
                    <div className="exit-intent-badge">Wait! Don't go yet</div>
                    <h2>Your items are waiting for you! 🛒</h2>
                    <p>
                        We noticed you have items in your cart. Complete your purchase now and get your favorites delivered to your doorstep.
                    </p>
                    <div className="exit-intent-actions">
                        <button className="continue-shopping-btn" onClick={handleContinue}>
                            View My Cart
                        </button>
                        <button className="dismiss-btn" onClick={handleClose}>
                            Maybe Later
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExitIntentPopup;
